import apiRequest from './api-request';
import { MetadataSettableType } from '../types';

export function getTenantProfile() {
    return apiRequest({
        method: 'GET',
        resource: 'tenant-profile'
    });
}

export function getTenantProfilePublic(id: string) {
    return apiRequest({
        method: 'GET',
        resource: `tenant-profile/${id}`
    });
}

export function recommendTenant(id: string): Promise<{
    status: 'created' | 'already_exists',
    name: string,
    slug: string | null
}> {
    return apiRequest({
        method: 'POST',
        resource: `tenant-profile/${id}/recommend`,
        body: {}
    });
}

export function updateTenantProfile(body: MetadataSettableType) {
    return apiRequest({
        method: 'PUT',
        resource: 'tenant-profile',
        body
    });
}

export function updateTenantMetadata(body: MetadataSettableType) {
    return apiRequest({
        method: 'PUT',
        resource: 'tenant-metadata',
        body
    });
}

export function searchTenants(body: string[]) {
    return apiRequest({
        method: 'POST',
        resource: 'tenant-search',
        body
    });
}

export function getPresignedLogoUrl(body: { mimeType: string }) {
    return apiRequest({
        method: 'POST',
        resource: 'tenant-profile/logo/presign',
        body
    })
}

export function confirmLogoUpload(body: { mimeType: string }) {
    return apiRequest({
        method: 'POST',
        resource: 'tenant-profile/logo/confirm',
        body
    })
}